import { useLang } from '@/i18n';
import EfSpec from '@elem/ui/ef-spec';
import EfImg from 'elem/ui/ef-img';
import EfTitle from 'elem/ui/ef-title';
import { useRouter } from 'next/router';
import styles from './index.module.scss';

export default function TheComp() {
    const { t } = useLang('hat');
    const { locale = 'us' } = useRouter();

    return (
        <div className={styles.TheComp}>
            <EfSpec className="spec-x" />
            <EfTitle>{t('D_title')}</EfTitle>
            <div className="yyds pc">
                <div className="l">
                    <div className="l-t">
                        <div className="l-t-l box">
                            <EfImg pc="https://websiteoss.ecoflow.com/upload/image/1726126136986/01.jpg" />
                            <p className="text">{t('D_text1')}</p>
                        </div>
                        <div className="l-t-r box">
                            <EfImg pc="https://websiteoss.ecoflow.com/upload/image/1726126137146/02.jpg" />
                            <p className="text">
                                {t.rich('D_text2', {
                                    b: (tx: string) => <span className="b">{tx}</span>,
                                })}
                            </p>
                        </div>
                    </div>
                    <div className="l-b">
                        <div className="l-b-l box">
                            <EfImg pc="https://websiteoss.ecoflow.com/upload/image/1726126217097/03.jpg" />
                            <p className="text">
                                {t.rich('D_text3', {
                                    b: (tx: string) => <span className="b">{tx}</span>,
                                    m: (tx: string) => <span className="m">{tx}</span>,
                                })}
                            </p>
                        </div>
                        <div className="l-b-r box">
                            <EfImg pc="https://websiteoss.ecoflow.com/upload/image/1726126138379/04.jpg" />
                            <p className="text">
                                {t.rich('D_text4', {
                                    b: (tx: string) => <span className="b">{tx}</span>,
                                })}
                            </p>
                        </div>
                    </div>
                </div>
                <div className="m">
                    <div className="m-t box">
                        <EfImg pc="https://websiteoss.ecoflow.com/upload/image/1726126137586/05.jpg" />
                        <p className="text">
                            {t.rich('D_text5', {
                                b: (tx: string) => <span className="b">{tx}</span>,
                            })}
                        </p>
                    </div>
                    <div className="m-b box">
                        <EfImg pc="https://websiteoss.ecoflow.com/upload/image/1726126138583/07.jpg" />
                        <p className="text">
                            {t.rich('D_text6', {
                                b: (tx: string) => <span className="b">{tx}</span>,
                            })}
                        </p>
                    </div>
                </div>
                <div className="r">
                    <div className="r-t box">
                        <EfImg pc="https://websiteoss.ecoflow.com/upload/image/1726126138084/08.jpg" />
                        <p className="text">
                            {t.rich('D_text7', {
                                b: (tx: string) => <span className="b">{tx}</span>,
                            })}
                        </p>
                    </div>
                    <div className="r-b box">
                        <EfImg pc="https://websiteoss.ecoflow.com/upload/image/1726126217302/06.jpg" />
                        <p className="text">
                            {t.rich('D_text8', {
                                b: (tx: string) => <span className="b">{tx}</span>,
                            })}
                        </p>
                    </div>
                </div>
            </div>
            <div className="yyds h5">
                <div className="l1 box">
                    <EfImg pc="https://websiteoss.ecoflow.com/upload/image/1726126429858/07.jpg" />
                    <p className="text">
                        {t.rich('D_text4', {
                            b: (tx: string) => <span className="b">{tx}</span>,
                        })}
                    </p>
                </div>
                <div className="l2">
                    <div className="l2-l box">
                        <EfImg pc="https://websiteoss.ecoflow.com/upload/image/1726126430365/06.jpg" />
                        <p className="text">
                            {t.rich('D_text7', {
                                b: (tx: string) => <span className="b">{tx}</span>,
                            })}
                        </p>
                    </div>
                    <div className="l2-r box">
                        <EfImg pc="https://websiteoss.ecoflow.com/upload/image/1726126431385/05.jpg" />
                        <p className="text">
                            {t.rich('D_text2', {
                                b: (tx: string) => <span className="b">{tx}</span>,
                            })}
                        </p>
                    </div>
                </div>
                <div className="l3">
                    <div className="l3-l box">
                        <EfImg pc="https://websiteoss.ecoflow.com/upload/image/1726126431458/04.jpg" />
                        <p className="text">
                            {t.rich('D_text3', {
                                b: (tx: string) => <span className="b">{tx}</span>,
                                m: (tx: string) => <span className="m">{tx}</span>,
                            })}
                        </p>
                    </div>
                    <div className="l3-r box">
                        <EfImg pc="https://websiteoss.ecoflow.com/upload/image/1726126430402/03.jpg" />
                        <p className="text">
                            {t.rich('D_text6', {
                                b: (tx: string) => <span className="b">{tx}</span>,
                            })}
                        </p>
                    </div>
                </div>
                <div className="l4">
                    <div className="l4-l box">
                        <EfImg pc="https://websiteoss.ecoflow.com/upload/image/1726126430966/02.jpg" />
                        <p className="text">
                            {t.rich('D_text5', {
                                b: (tx: string) => <span className="b">{tx}</span>,
                            })}
                        </p>
                    </div>
                    <div className="l4-r box">
                        <EfImg pc="https://websiteoss.ecoflow.com/upload/image/1726126429817/01.jpg" />
                        <p className="text">
                            {t.rich('D_text8', {
                                b: (tx: string) => <span className="b">{tx}</span>,
                            })}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}
